import { DemDetailComponent } from './dem-detail/dem-detail.component';
import { Component, OnInit, OnDestroy } from '@angular/core';
//OpenLayers Import
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { DragBox } from 'ol/interaction';
import WKT from 'ol/format/WKT';
import { getCenter } from 'ol/extent';
// services
import { MapServiceService } from '../../../services/Map-service/map-service.service';
import { getArea } from 'ol/sphere';
import { Fill, Stroke, Style } from 'ol/style';
import { SideNavService } from '../../../services/sidenav/side-nav.service';
import { HttpClient } from '@angular/common/http';
import { fromLonLat, transform } from 'ol/proj';
import { DemService } from '../../../services/demService/dem.service';
import { finalize, tap } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import * as CryptoJS from 'crypto-js';
@Component({
  selector: 'app-dem-downloader',
  templateUrl: './dem-downloader.component.html',
  styleUrls: ['./dem-downloader.component.css']
})
export class DemDownloaderComponent implements OnInit, OnDestroy {
  vectorDrawSource: any
  draw: any;
  rmInteraction: any;
  area: any
  polygonData: any;
  readyToDownload = false
  processingStart = false
  drawPolygon = false
  isDisabled = true;
  isActive = false;
  loading = false;
  //DEM Data
  coverageSize: any = 0
  centroidCoordinate: any= 0
  estimateSize: any = 0
  outputDimmensions: any= 0
  horixentalResolution: any = 0
  verticalResolution: any= 0
  widthDimmension: any = 0
  heightDimmension: any = 0
  userEn = 'userEncrpto';
  decrypted: any;
  userId: any
  //
  match: any;
  uniqueName: any;
  counter = 1;
  copy: any;
  check: any;
  saveViewTitle: any
  mapId: any
  allDemFiles: any
  value: any;
  demID: any
  demFileName: any
  getDemId: any
  //
  feature: any
  multistyle: any
  //
  downloadTip = '<span>Download</span>';
  myDownload = {
    showDelay: 500,
    'tooltip-class': 'new-tooltip-class15',
  };
  processingTip = '<span>Your DEM file is being compiled from USGS data and will be available shortly.</span>';
  myprocessing = {
    showDelay: 500,
    'tooltip-class': 'new-tooltip-class14',
  };
  constructor(
    public mapServices: MapServiceService,
    private sideNavService: SideNavService,
    private http: HttpClient,
    public demService: DemService,
    private spinner: NgxSpinnerService,
    ) {

     }

  ngOnInit(): void {
    this.mapId = this.mapServices.mapData.map_data.map_data.id.toString();
    this.vectorDrawSource = new VectorSource();
    this.mapServices.DEMLayer = new VectorLayer({
      source: this.vectorDrawSource,
    });
    this.decrypted = localStorage.getItem('user') || '';
    if (!this.decrypted) {
      this.userId = '0';
    } else {
      const decrypted = CryptoJS.AES.decrypt(this.decrypted, this.userEn);
      const user = decrypted.toString(CryptoJS.enc.Utf8);
      const userdetail = JSON.parse(user);
      if (userdetail) {
        this.userId = userdetail.user.id;
      }
    }
    this.mapServices.mapLayer.addLayer(this.mapServices.DEMLayer);
    this.getAllDemFile();
    this.demService.refreshDemList.subscribe((res: any) => {
      if (res) {
        this.getAllDemFile();
      }
    });
    this.demService.deleteDemListData.subscribe((res: any) => {
      this.demDeleteFromList(res);
    });

    this.mapServices.drawFeatureData.subscribe((res: any) => {
      this.getDemId = res;
      this.selectedFeature(this.getDemId)
    });
    // this.mapServices.getdrawEnable(true)
  }
  getAllDemFile() {
    this.spinner.show();
    this.demService.getAllDEM(this.mapId).subscribe((res: any) => {
      this.allDemFiles = res
      this.allDemFiles.sort((a: any, b: any) => {
        return a.name.localeCompare(b.name, undefined, {
          numeric: true,
          sensitivity: 'base',
        });
      });
      this.drawPlogon()
      this.spinner.hide();
     })
  }

  drawPlogon() {
    for (let i = 0; i < this.allDemFiles.length; i++) {
      const f = this.allDemFiles[i];
      const format = new WKT();
      const str = f.polygon.replace("SRID=4326;", "");
      this.feature = format.readFeature(str);
      this.feature.set('number', this.allDemFiles[i].id);
      this.multistyle = new Style({
        fill: new Fill({
          color: 'rgb(255, 204, 51,0.3)',
        }),
        stroke: new Stroke({
          color: '#0085da',
          width: 1,
        }),
      });
      this.feature.setStyle(this.multistyle);
      this.vectorDrawSource.addFeatures([this.feature]);
    }

  }


  addInteraction() {
    const layer = this.mapServices.DEMLayer;
      this.draw = new DragBox({
        className: 'drag',
      });
       // formatArea for polygon
      const formatArea = (polygon: any) => {
        this.area = getArea(polygon);
        return this.area;
      };
      this.rmInteraction = this.draw;
      this.mapServices.mapLayer.addInteraction(this.draw);
      this.draw.on('boxstart', () => {
        // this.unitestpass = true;
      });
      this.draw.on('boxend', (evt: any) => {
        const geom = evt.target.getGeometry();
        const wkt = new WKT();
        const area = formatArea(geom)
        this.polygonData = wkt.writeGeometry(geom);
        this.findAreaInAC(area)
        this.findcentroid(geom)
        this.findEstimatedSize(area)
        this.findOutPutDemensions(geom)
        this.findHorizontalResolution(geom)
        this.findVerticalResolution(geom)
        this.isDisabled = false
        this.drawExtent()
        this.mapServices.getdrawEnable(false);
      });
    //unit test checks ends
  }

  drawBox(): void {
    this.isActive = !this.isActive;
    if(this.isActive) {
      this.drawPolygon = true
      const source = this.mapServices.DEMLayer.getSource();
      const features = source.getFeatures();
      features.forEach((feature: any) => {
        source.removeFeature(feature);
      });
      this.sideNavService.closeRightSideNav();
      this.demService.selectedId = 0
      this.processingStart = false
      this.getAllDemFile()
      this.addInteraction()
    } else {
      this.drawPolygon = false
      const source = this.mapServices.DEMLayer.getSource();
      const features = source.getFeatures();
      features.forEach((feature: any) => {
        source.removeFeature(feature);
      });
      this.getAllDemFile()
      this.processingStart = false
      this.coverageSize = 0
      this.estimateSize = 0
      this.centroidCoordinate = 0 , 0
      this.outputDimmensions = 0 * 0
      this.horixentalResolution  =0
      this.verticalResolution = 0
      this.mapServices.mapLayer.removeInteraction(this.draw);
    }

  }

  findAreaInAC(area: any): void {
    const meterSqaureToAcres = area * 0.000247105;
    this.coverageSize = this.roundNumber(+meterSqaureToAcres, 2)
  }

  findcentroid(coordinates: any): void {
    const getExtent = coordinates.getExtent();
    const getcentroid = getCenter(getExtent);
    const data = transform(getcentroid ,'EPSG:3857', 'EPSG:4326')
    this.centroidCoordinate = `${this.roundNumber(data[0], 3)} , ${this.roundNumber(data[1], 3)} `
  }

  findEstimatedSize(area: any): void {
    // assuming 16 bytes per square meter (rough estimate)
    const bytes = area * 16;
    const mb = bytes / (1024 * 1024);
    this.estimateSize = this.roundNumber(+mb, 0) + 'MB';
  }

  findOutPutDemensions(geom: any): void {
    const bbox = geom.getExtent();
    const width = bbox[2] - bbox[0];
    const height = bbox[3] - bbox[1];
    this.widthDimmension = this.roundNumber(width, 0);
    this.heightDimmension = this.roundNumber(height, 0)
    this.outputDimmensions = `${this.roundNumber(width, 0)} x ${this.roundNumber(height, 0)}  pixels`
  }

  findHorizontalResolution(geom: any): void {
    const bbox = geom.getExtent();
    // Get the size of the map in pixels
    const mapSize = this.mapServices.mapLayer.getSize();
    // Calculate the width of the bounding box
    const bboxWidth = bbox[2] - bbox[0];
    // Calculate the horizontal resolution of the polygon
    const resolution = bboxWidth / mapSize[0];
    // this.horixentalResolution = this.roundNumber(resolution, 2) + 'm';
    this.horixentalResolution = 10;
  }

  findVerticalResolution(geom: any) {
    const bbox = geom.getExtent();
    // Get the size of the map in pixels
    const mapSize = this.mapServices.mapLayer.getSize();
    // Calculate the width of the bounding box
    const bboxWidth = bbox[3] - bbox[1];
    // Calculate the horizontal resolution of the polygon
    const verResolution = bboxWidth / mapSize[1];
    // this.verticalResolution = this.roundNumber(verResolution, 2) + 'in';
    this.verticalResolution = 6;
  }

  // number into 6 digit
  roundNumber(num: any, dec: any) {
    return Math.round(num * Math.pow(10, dec)) / Math.pow(10, dec);
  }

  go(): void {
    this.getUniqueName()
    this.drawPolygon = false
    const body  ={
      tiff_filename: null,
      polygon: this.polygonData,
      name: this.saveViewTitle,
      coverage_size: this.coverageSize,
      centroid: this.centroidCoordinate,
      coordinate_system: "3857",
      estimated_file_size: `${this.estimateSize}`,
      original_file_size: null,
      buffer: 1,
      horizontal_resolution: `10m`,
      vertical_resolution: `6in`,
      height: this.widthDimmension.toString(),
      width: this.heightDimmension.toString(),
      user: this.userId,
      map: this.mapId
    }
    this.demService.addDemFile(body).pipe(
      tap((res) => {
        this.demID = res.id
      }),
      finalize(() => {
        this.demService.getDEMTiff(this.demID).pipe(
          tap((res: any) => {
            this.demFileName = res.filename
            // this.demService.setRefreshDem('res');
          }),
          finalize(() => {
            this.processingComplete()
          })
        )
        .subscribe();
      })
    )
    .subscribe();

  }

  drawExtent(): void {
    this.processingStart = false
    this.readyToDownload = false
    const source = this.mapServices.DEMLayer.getSource();
    const features = source.getFeatures();
    features.forEach((feature: any) => {
      source.removeFeature(feature);
    });
    let feature: any = null;
    const wkt = new WKT();
    feature = wkt.readFeature(this.polygonData);
    feature.setStyle(this.polygonStyle());
    this.vectorDrawSource.addFeatures([feature]);
    this.processingStart = true

  }
   //function that return polygon style for annotation
   polygonStyle() {
    return new Style({
      fill: new Fill({
        color: 'rgb(255, 204, 51,0.3)',
      }),
      stroke: new Stroke({
        color: '#0085da',
        width: 2,
        lineDash: [8],
      }),
    });
  }

  polygonStyle1() {
    return new Style({
      fill: new Fill({
        color: 'rgb(255, 204, 51,0.3)',
      }),
      stroke: new Stroke({
        color: '#0085da',
        width: 2,
      }),
    });
  }

  clickOnFeature(item: any) {
    this.sideNavService.rightMenuClicked({
      component: DemDetailComponent,
      history: false,
      push: false,
    });
    this.demService.demData = item
    this.sideNavService.sideNavState('open');
    this.selectedFeature(item.id)
  }

  processingComplete(): void {
    this.readyToDownload = true
    this.isActive = false
    this.drawPolygon = false
    this.mapServices.mapLayer.removeInteraction(this.draw);
    const source = this.mapServices.DEMLayer.getSource();
    const features = source.getFeatures();
    features.forEach((feature: any) => {
      feature.setStyle(this.polygonStyle1());
      this.vectorDrawSource.addFeatures([feature]);
    });
  }

  downloadTiffFile(fileName: any): void {
    this.spinner.show()
    const url = `${this.sideNavService.downloadFileUrl}/media/dem/${fileName}`
    this.http.get(url, { responseType: 'blob' }).subscribe((res: Blob) => {
      const link = document.createElement('a');
      this.loading = false
      link.href = URL.createObjectURL(res);
      link.download = `${fileName}`;
      link.click();
      this.spinner.hide()
    });
  }


  getUniqueName() {
    let counter = 1;
    let lastCounter: any
    const names: string[] = [];
    for (const item of this.allDemFiles) {
      names.push(item.name);
    }
    const lastFileName = names[names.length - 1];
    if(lastFileName) {
      lastCounter = parseInt(lastFileName.split("")[2]);
    }

    if (lastCounter >= counter) {
      counter = lastCounter + 1;
    }

    let newFileName = "DEM Coverage " + counter;

    while (names.includes(newFileName)) {
      counter++;
      newFileName = "DEM Coverage " + counter;
    }

    this.saveViewTitle = newFileName;
  }

  demDeleteFromList(res: any) {
    const source = this.mapServices.DEMLayer.getSource();
    const features = source.getFeatures();
    features.forEach((feature: any) => {
      source.removeFeature(feature);
    });
    this.getAllDemFile()
    this.removeFeatureFromLayer(res)
    this.sideNavService.closeRightSideNav();
  }

  selectedFeature(id: any) {
    if(this.demService.selectedId) {
      for (let i = 0; i < this.allDemFiles.length; i++) {
        const f = this.allDemFiles[i];
        if(f.id === this.demService.selectedId) {
          const format = new WKT();
          const str = f.polygon.replace("SRID=4326;", "");
          this.feature = format.readFeature(str);
          this.feature.set('number', this.allDemFiles[i].id);
          this.multistyle = new Style({
            fill: new Fill({
              color: 'rgb(255, 204, 51,0.3)',
            }),
            stroke: new Stroke({
              color: '#0085da',
              width: 1,
            }),
          });
          this.feature.setStyle(this.multistyle);
          this.vectorDrawSource.addFeatures([this.feature]);
        }
      }
   }
    for (let i = 0; i < this.allDemFiles.length; i++) {
      this.drawPolygon = false
      const f = this.allDemFiles[i];
      if(f.id == id) {
        this.sideNavService.rightMenuClicked({
          component: DemDetailComponent,
          history: false,
          push: false,
        });
        this.demService.selectedId = id
        this.demService.demData = f
        this.sideNavService.sideNavState('open');
        this.removeFeatureFromLayer(id)
        const format = new WKT();
        const str = f.polygon.replace("SRID=4326;", "");
        this.feature = format.readFeature(str);
        this.feature.set('number', this.allDemFiles[i].id);
        this.multistyle = new Style({
          fill: new Fill({
            color: 'rgb(255, 99, 71, 0.3)',
          }),
          stroke: new Stroke({
            color: '#0085da',
            width: 1,
          }),
        });
        this.feature.setStyle(this.multistyle);
        this.vectorDrawSource.addFeatures([this.feature]);
      }
   }
  }

  removeFeatureFromLayer(id: any) {
    const source = this.mapServices.DEMLayer.getSource();
    const features = source.getFeatures();
    features.forEach((feature: any) => {
      if(feature.get('number') === id) {
        source.removeFeature(feature);
      }

    });
  }

  closeLeft() {
    this.mapServices.closePanel = true;
    this.mapServices.setClosePanel(true);
    const source = this.mapServices.DEMLayer.getSource();
    const features = source.getFeatures();
    features.forEach((feature: any) => {
      source.removeFeature(feature);
    });
  }


  ngOnDestroy(): void {
    this.mapServices.DEMLayer && this.mapServices.DEMLayer.getSource().clear();
    this.mapServices.mapLayer.removeInteraction(this.draw);
    this.sideNavService.closeRightSideNav();
    const source = this.mapServices.DEMLayer.getSource();
    const features = source.getFeatures();
    features.forEach((feature: any) => {
      source.removeFeature(feature);
    });
  }
}
